import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useT } from '../../../../lib/i18n';
import { formatDate } from '../../ui';
import { TicketStatus } from './TicketDialog';

/** My Support Tickets: number, subject, category, status, dates and View. Owners and admins see the whole company's. */
export default function MyTickets({ data, onView, onViewAll, showAll }) {
  const { t } = useT();
  const rows = data?.items || [];
  return (
    <section className="panel hs-panel">
      <div className="hs-panel-head">
        <div><h2>{data?.sees_all ? t('Support Tickets') : t('My Support Tickets')}</h2><p>{t('Track the status of your support requests.')}</p></div>
        {data && data.total > rows.length && !showAll && <button type="button" className="hs-view-all" onClick={onViewAll}>{t('View All')} <ArrowRight size={12} /></button>}
      </div>
      <div className="table-scroll">
        <table className="hs-table">
          <thead><tr><th>{t('Ticket ID')}</th><th>{t('Subject')}</th><th>{t('Category')}</th><th>{t('Status')}</th><th>{t('Created On')}</th><th>{t('Updated On')}</th><th>{t('Action')}</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td className="hs-num">#{r.number}</td>
                <td className="hs-subject">{r.subject}{data.sees_all && <small>{r.opened_by}</small>}</td>
                <td>{t(r.category)}</td>
                <td><TicketStatus ticket={r} t={t} />{r.last_reply_by === 'staff' && r.status !== 'closed' && <i className="hs-new" title={t('New reply')} />}</td>
                <td>{formatDate(r.created_at)}</td>
                <td>{formatDate(r.updated_at)}</td>
                <td><button type="button" className="hs-view" onClick={() => onView(r.id)}>{t('View')}</button></td>
              </tr>
            ))}
            {data && rows.length === 0 && <tr><td colSpan={7} className="hs-empty">{t('No tickets yet. Need help? Open one above.')}</td></tr>}
            {!data && <tr><td colSpan={7} className="hs-empty">{t('Loading…')}</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
